import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=71222870&"
import script from "./FormRender.vue?vue&type=script&lang=js&"
export * from "./FormRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports